import { BasePage } from "../components/base-page";
import { HistoricalTranscriptsTable } from "../core/historical-transcripts/historical-transcripts-table/historical-transcripts-table";

export function TranscriptionsPage() {
  return (
    <BasePage footer={false}>
      <div className="m-auto mt-3 flex w-full max-w-[100vw] flex-auto justify-center gap-10 overflow-hidden">
        <HistoricalTranscriptsTable />
      </div>
    </BasePage>
  );
}
